import  { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Sidebar from "./SideBar/Sidebar";
import Rooot from "./Root/Root";
import logo from "./assets/ll.png";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { app, db } from "./components/Admin/Config/Config";
import Login from "./components/Auth/Login";
import Loading from "./components/Loading/Loading";
import { useLoading } from "./components/Loading/LoadingContext";
import { useUser } from "./components/Auth/UsersContext";
import RegPopUp from "./components/Auth/RegPopUP";
import { doc, onSnapshot, updateDoc } from "firebase/firestore";
import Paymentsuccess from "./components/Payment/Paymentsuccess";
import { MoveLeftIcon } from "lucide-react";

const App = () => {
    const { user } = useUser();
    const [regPopUp, setRegPopUp] = useState(false);

  useEffect(()=>{
    if(user&&(user.mobile===""|| !user.district|| !user.email)){
      setRegPopUp(true);
    }
    if(user&&user.study_stream!=="Jaffers English"){
      updateDoc(doc(db, "users", user.uid), {
        study_stream: "Jaffers English",
      });
    }
  },[user])
    const { triggerLoading } = useLoading();
  const [isSidebarOpen, setIsSidebarOpen] = useState(() => {
    const savedState = localStorage.getItem("isSidebarOpen");
    return savedState ? JSON.parse(savedState) : false;
  });

  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(() => {
    const savedState = localStorage.getItem("isSidebarCollapsed");
    return savedState ? JSON.parse(savedState) : false;
  });

  const location = useLocation();
  const navigate = useNavigate(); 

  const setSidebarState = (value) => {
    setIsSidebarOpen(value);
    localStorage.setItem("isSidebarOpen", JSON.stringify(value));
  };

  const setCollapsedState = (value) => {
    setIsSidebarCollapsed(value);
    localStorage.setItem("isSidebarCollapsed", JSON.stringify(value));
  };

  const toggleSidebar = () => {
    setSidebarState(!isSidebarOpen);
    if (isSidebarCollapsed) setCollapsedState(false);
  };

  const toggleSidebarCollapse = () => {
    setCollapsedState(!isSidebarCollapsed);
    setSidebarState(false);
  };

  // Close sidebar when route changes
  useEffect(() => {
    setSidebarState(false);
  }, [location.pathname]);

    const auth = getAuth(app);
    const [isLoggedIn, setIsLoggedIn] = useState(false);

    useEffect(() => {
      onAuthStateChanged(auth, (user) => {
        setIsLoggedIn(!!user);
        if(user){
          triggerLoading(false);
          priceStatus();
        } else {
          triggerLoading(false);
        }
      });
    }, [auth, triggerLoading]);
    
      const [pricestatus, setPriceStatus] = useState(false);
      const priceStatus = async () => {
        const ref = doc(db, "app_price", "app_price");
        const unsubscribe = onSnapshot(ref, (docSnap) => {
          if (docSnap.exists()) {
            const data = docSnap.data();
            setPriceStatus(data.price_status);
          }
        });
        return unsubscribe;
      };

  return (
    <>
      {pricestatus || !isLoggedIn ? (
        <div className="flex flex-col h-screen">
          {isLoggedIn ? (
            <header className="bg-black text-gray-100 p-4 flex border-b border-gray-800/80  justify-between items-center z-50 sticky top-0 w-full flex-shrink-0">
              <div className="flex items-center">
                <img
                  src={logo}
                  alt="Logo"
                  className="w-6 h-6 object-cover ml-3"
                />
                <a
                  href="/Home"
                  className="ml-3 text-white font-semibold hover:text-gray-200 transition-colors"
                >
                  Bristu E-Learning
                </a>

                <button
                  className="hidden xl:flex items-center ml-16 text-white hover:text-gray-300 transition-colors"
                  onClick={toggleSidebarCollapse}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    className="w-6 h-6 mr-2"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M4 6h16M4 12h16M4 18h16"
                    />
                  </svg>
                </button>
                <div className="flex-1 flex justify-start ml-10">
                  <button
                  onClick={()=>navigate(-1)}
                    className="bg-emerald-900/80 hover:bg-emerald-400/20 
                                rounded-full p-3 border-2 border-emerald-700 hover:border-emerald-400/50
                                text-emerald-200 hover:text-white
                                transition-all duration-200 shadow-lg hover:shadow-emerald-500/20"
                  >
                    <MoveLeftIcon className="w-6 h-6" />
                  </button>
                </div>
              </div>

              <div className="flex items-center space-x-4">
                <button className="block xl:hidden" onClick={toggleSidebar}>
                  {isSidebarOpen ? (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      className="w-6 h-6 text-white"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  ) : (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      className="w-6 h-6 text-white"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M4 6h16M4 12h16M4 18h16"
                      />
                    </svg>
                  )}
                </button>

                <div className="flex items-center space-x-4 hidden xl:flex p-1 rounded-lg transition-all duration-300 cursor-pointer group">
                  <div className="relative">
                    <img
                      className="w-10 h-10 rounded-full object-cover ring-2 ring-blue-100 group-hover:ring-blue-200 transition-all duration-300 transform group-hover:scale-105"
                      src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQACGFpr0iqURE_6EHYMm-AGXfhXC1Nzf4ucA&s"
                      alt="User avatar"
                    />
                    <div className="absolute bottom-0 right-0 w-3 h-3 bg-green-400 rounded-full ring-2 ring-white"></div>
                  </div>

                  <div
                    className="pr-4 cursor-pointer"
                    onClick={() => navigate("/profile")}
                  >
                    <p className="text-sm font-bold text-gray-100 font-poppins">
                      {user?.name ?? ""}
                    </p>
                    <p className="text-xs text-gray-100 font-poppins">
                      {user?.email ?? ""}
                    </p>
                  </div>
                </div>
              </div>
            </header>
          ) : null}

          <div className="flex flex-1 overflow-hidden">
            {isLoggedIn ? (
              <>
                <Paymentsuccess />
                {isSidebarOpen && (
                  <div
                    className="fixed inset-0 bg-black bg-opacity-50 z-10 xl:hidden"
                    onClick={() => setSidebarState(false)}
                  ></div>
                )}

                <Sidebar
                  isSidebarOpen={isSidebarOpen}
                  setSidebarState={setSidebarState}
                  isSidebarCollapsed={isSidebarCollapsed}
                  setCollapsedState={setCollapsedState}
                />
              </>
            ) : null}
            <main className="flex-1 xl:ml-0 overflow-y-auto">
              <Rooot />
            </main>
          </div>
          <Login />
          <Loading />
          <RegPopUp toogle={regPopUp} user={user} />
        </div>
      ) : null}
    </>
  );
};

export default App;